import { useScreenSize } from '@banhala/ui-kit';
import { useMemo } from 'react';

const HORIZONTAL_PADDING = 16;
const PHOTO_BOX_GAP = 4;

export const usePhotoReviewSize = () => {
  const { width: screenWidth } = useScreenSize();

  return useMemo(() => {
    return (screenWidth - HORIZONTAL_PADDING * 2 - PHOTO_BOX_GAP * 3) / 4;
  }, [screenWidth]);
};
